export const CATEGORY_ADD_LIST = "CATEGORY_ADD_LIST";